var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLikeOffFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13.5003 22.9397L11.9295 21.5097C6.35033 16.4505 2.66699 13.1139 2.66699 9.01888C2.66699 5.68221 5.28866 3.06055 8.62533 3.06055C10.5103 3.06055 12.3195 3.93805 13.5003 5.32471C14.6812 3.93805 16.4903 3.06055 18.3753 3.06055C21.712 3.06055 24.3337 5.68221 24.3337 9.01888C24.3337 13.1139 20.6503 16.4505 15.0712 21.5205L13.5003 22.9397Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M12.4339 20.955L12.4328 20.954C9.62814 18.4107 7.36105 16.3533 5.78611 14.4278C4.21977 12.5128 3.4165 10.8199 3.4165 9.01876C3.4165 6.09631 5.70238 3.81042 8.62484 3.81042C10.2827 3.81042 11.8857 4.58588 12.9288 5.81085C13.0713 5.97818 13.28 6.07459 13.4998 6.07459C13.7196 6.07459 13.9284 5.97818 14.0708 5.81085C15.114 4.58588 16.7169 3.81042 18.3748 3.81042C21.2973 3.81042 23.5832 6.0963 23.5832 9.01876C23.5832 10.8199 22.7799 12.5128 21.2134 14.4293C19.6387 16.3559 17.3723 18.4154 14.5685 20.9633L14.5679 20.9639L14.5663 20.9654L13.5018 21.9271L12.4339 20.955Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLikeOffFill);
export default __webpack_public_path__ + "static/media/ic_like_off_fill.386bed63d08ce03f556ef741302e313c.svg";
export { ForwardRef as ReactComponent };